import React, { Dispatch, SetStateAction } from 'react';
import { Tooltip } from './images/svg/icons';
import { handleToggle } from '../helper/salary.helpers';
import GenericTooltip from './generictooltip';

export const AmountInput: React.FC<{
    value: number;
    placeholder?: string;
    currency: string;
    label?: string;
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}> = ({ label, value, placeholder = '0', currency, onChange }) => (
    <div>
        {label && <label className="form-label me-2">{label}</label>}
        <div className="d-flex align-items-center  position-relative width-310 border-color-gray" style={{ borderRadius: '6px', border: '1px solid #EAEBF0' }}>
            <input
                type="number"
                className="form-control border-0 p-0 px-2 shadow-none mb-0 "
                placeholder={placeholder}
                value={value || ''}
                style={{ flex: 1 }}
                onChange={onChange}
            />
            <div className="vr mx-2" style={{ height: '46px' }} />
            <span className='px-2' style={{
                opacity: 0.5
            }}>{currency}</span>
        </div>
    </div>
);

export const TooltipLabel: React.FC<{
    label: string;
    tooltipId: string;
    tooltipActiveId: string | null;
    setTooltipActiveId: Dispatch<SetStateAction<string | null>>;
    t: (key: string) => string;
    tooltipLabel: string;
}> = ({ label, tooltipId, tooltipActiveId, setTooltipActiveId, t, tooltipLabel }) => (
    <>
        {label && <label className="form-label me-2">{label}</label>}

        <img
            src={Tooltip}
            className="tooltip-svg cursor-pointer"
            onClick={() => handleToggle(setTooltipActiveId, tooltipId)}
            alt=""
        />
        <GenericTooltip
            isActive={tooltipActiveId === tooltipId}
            content={t(tooltipLabel)}
            onClose={() => setTooltipActiveId(null)}
            width="w-50"
            position="left-0"
            zIndex="z-index-9"
        />
    </>
);

export const CheckboxWithLabel: React.FC<{
    onChange: (checked: boolean) => void;
    checked?: boolean;
    label: string;
    tooltipId: string;
    tooltipActiveId: string | null;
    setTooltipActiveId: Dispatch<SetStateAction<string | null>>;
    tooltipLabel: string;
    isTooltip?: boolean;
    disabled?: boolean;
}> = ({ checked, onChange, label, tooltipId, tooltipActiveId, setTooltipActiveId, tooltipLabel, isTooltip = true , disabled }) => (
    <>
        <input
            className="form-check-input ml-0 pl-0  mb-1 custom-checkbox"
            type="checkbox"
            checked={checked}
            disabled={disabled}
            onChange={e => onChange(e.target.checked)}
        />
        <span className="form-check-label mb-0 ml-4 text-free-style">
            {label}
        </span>
        {isTooltip &&
            <>
                <img
                    src={Tooltip}
                    className="tooltip-svg cursor-pointer"
                    onClick={() => handleToggle(setTooltipActiveId, tooltipId)}
                    alt=""
                />
                <GenericTooltip
                    isActive={tooltipActiveId === tooltipId}
                    content={tooltipLabel}
                    onClose={() => setTooltipActiveId(null)}
                    width="w-50"
                    position="left-0"
                    zIndex="z-index-9"
                />
            </>
        }
    </>
);
